module.exports = __webpack_public_path__ + "static/media/bibijorissen.0ef96b94.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/bibijorissen.webp
// module id = 531
// module chunks = 0